'use client';

import classnames from 'classnames/bind';
import { memo, useEffect } from 'react';
import { EAnalytics } from '@/_constants/analytics';
import { useAnalytics } from '@/_hooks/use-analytics';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'HeaderObserver';

export const HeaderObserver = memo(function HeaderObserver() {
  const sendEvent = useAnalytics();

  useEffect(() => {
    const config = {
      name: EAnalytics.SUPPLIER_LANDING_HEADER_ELEMENT_V,
    };

    sendEvent(config);
  }, [sendEvent]);

  return <div className={cn(BLOCK_NAME)} />;
});
